var _defs, _rect, _circle, _circle2, _rect2, _circle3, _circle4, _circle5, _rect3, _text, _rect4, _path, _text2, _text3, _rect5, _circle6, _text4, _rect6, _text5, _g, _circle7, _circle8, _path2, _rect7, _rect8, _text6, _rect9, _text7, _rect10, _text8, _text9, _rect11, _rect12, _text10, _rect13, _circle9, _text11, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadiologyAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 720",
    width: 1280,
    height: 720,
    fontFamily: "'Segoe UI','Helvetica Neue',Arial,sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a1526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e2138"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cyan",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22d3ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38bdf8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22d3ee",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22d3ee",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "heat",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4d3d",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff8a3d",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8a3d",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1120,
    cy: 120,
    r: 320,
    fill: "url(#glow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 640,
    r: 260,
    fill: "url(#glow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 92,
    width: 1040,
    height: 536,
    rx: 24,
    fill: "#0c1d33",
    stroke: "#1e3a5f",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 126,
    r: 6,
    fill: "#ff5f56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 126,
    r: 6,
    fill: "#ffbd2e"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 126,
    r: 6,
    fill: "#27c93f"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 113,
    width: 340,
    height: 27,
    rx: 13.5,
    fill: "#0a1626",
    stroke: "#1e3a5f"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 131,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#6b86a6"
  }, "radiologyai-assistant.app")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 162,
    width: 46,
    height: 46,
    rx: 12,
    fill: "url(#cyan)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175 172 v26 M162 185 h26",
    stroke: "#0a1526",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 212,
    y: 184,
    fill: "#ffffff",
    fontSize: 25,
    fontWeight: 700
  }, "RadiologyAI Assistant")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 213,
    y: 205,
    fill: "#7f9bb8",
    fontSize: 14
  }, "AI X-ray Analysis Platform")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 980,
    y: 168,
    width: 150,
    height: 34,
    rx: 17,
    fill: "#0c2a22",
    stroke: "#1f6f52"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1002,
    cy: 185,
    r: 5,
    fill: "#34d399"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 1016,
    y: 190,
    fill: "#5fe0a8",
    fontSize: 13,
    fontWeight: 600
  }, "Analysis Complete")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 232,
    width: 560,
    height: 330,
    rx: 16,
    fill: "#060e1a",
    stroke: "#16304d"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 176,
    y: 262,
    fill: "#4d80a8",
    fontSize: 12,
    letterSpacing: 1.5
  }, "CHEST X-RAY \xB7 PA VIEW")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#274b70",
    strokeWidth: 3,
    fill: "none",
    opacity: 0.55,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427,
    y: 290,
    width: 8,
    height: 230,
    rx: 4,
    fill: "#274b70",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 300 Q345 315 305 360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 335 Q335 352 292 405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 372 Q332 392 292 450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 410 Q340 432 300 492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 300 Q517 315 557 360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 335 Q527 352 570 405"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 372 Q530 392 570 450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 410 Q522 432 562 492"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 425,
    r: 95,
    fill: "url(#heat)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 425,
    r: 30,
    fill: "none",
    stroke: "#ff6a4d",
    strokeWidth: 2,
    opacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M350 405 v40 M330 425 h40",
    stroke: "#ff8a6d",
    strokeWidth: 1.5,
    opacity: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 392,
    width: 528,
    height: 2,
    fill: "url(#cyan)",
    opacity: 0.35
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 502,
    width: 168,
    height: 40,
    rx: 10,
    fill: "#0b2a33",
    stroke: "#22758a"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 194,
    y: 527,
    fill: "#67e8f9",
    fontSize: 14,
    fontWeight: 600
  }, "Confidence \xB7 92%")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 502,
    width: 196,
    height: 40,
    rx: 10,
    fill: "#33210f",
    stroke: "#a8641f"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 374,
    y: 527,
    fill: "#ffb266",
    fontSize: 14,
    fontWeight: 600
  }, "Finding \xB7 Pneumonia")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 232,
    width: 272,
    height: 150,
    rx: 14,
    fill: "#102237",
    stroke: "#1e3a5f"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 266,
    fill: "#7f9bb8",
    fontSize: 12,
    letterSpacing: 1.5
  }, "AI PREDICTION")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 300,
    fill: "#ffffff",
    fontSize: 26,
    fontWeight: 700
  }, "Pneumonia")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 322,
    width: 224,
    height: 10,
    rx: 5,
    fill: "#1b3350"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 322,
    width: 206,
    height: 10,
    rx: 5,
    fill: "url(#cyan)"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 360,
    fill: "#8fb0cf",
    fontSize: 13
  }, "Probability 92% \xB7 Model transparency")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 398,
    width: 272,
    height: 164,
    rx: 14,
    fill: "#102237",
    stroke: "#1e3a5f"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 758,
    cy: 426,
    r: 5,
    fill: "#22d3ee"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 772,
    y: 431,
    fill: "#cfe3f5",
    fontSize: 14,
    fontWeight: 600
  }, "AI Assistant")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 446,
    width: 150,
    height: 42,
    rx: 12,
    fill: "#17304d"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 774,
    y: 460,
    width: 118,
    height: 6,
    rx: 3,
    fill: "#3f6187"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 774,
    y: 472,
    width: 86,
    height: 6,
    rx: 3,
    fill: "#3f6187"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 838,
    y: 498,
    width: 146,
    height: 30,
    rx: 12,
    fill: "#123b44"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 852,
    y: 510,
    width: 112,
    height: 6,
    rx: 3,
    fill: "#2b7f92"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 536,
    width: 130,
    height: 18,
    rx: 9,
    fill: "#17304d"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 772,
    y: 542,
    width: 90,
    height: 6,
    rx: 3,
    fill: "#3f6187"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontSize: 13,
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 580,
    width: 86,
    height: 30,
    rx: 15,
    fill: "#0f2137",
    stroke: "#254a6e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 600,
    fill: "#9cc0e0",
    textAnchor: "middle"
  }, "Next.js"), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 580,
    width: 92,
    height: 30,
    rx: 15,
    fill: "#0f2137",
    stroke: "#254a6e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 294,
    y: 600,
    fill: "#9cc0e0",
    textAnchor: "middle"
  }, "FastAPI"), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 580,
    width: 92,
    height: 30,
    rx: 15,
    fill: "#0f2137",
    stroke: "#254a6e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 396,
    y: 600,
    fill: "#9cc0e0",
    textAnchor: "middle"
  }, "PyTorch"), /*#__PURE__*/React.createElement("rect", {
    x: 452,
    y: 580,
    width: 86,
    height: 30,
    rx: 15,
    fill: "#0f2137",
    stroke: "#254a6e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 495,
    y: 600,
    fill: "#9cc0e0",
    textAnchor: "middle"
  }, "Python"), /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 580,
    width: 102,
    height: 30,
    rx: 15,
    fill: "#0f2137",
    stroke: "#254a6e"
  }), /*#__PURE__*/React.createElement("text", {
    x: 599,
    y: 600,
    fill: "#9cc0e0",
    textAnchor: "middle"
  }, "Groq LLM"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiologyAi);
export default __webpack_public_path__ + "static/media/radiology-ai.f759203e15cd8a259aae6a8cea650f47.svg";
export { ForwardRef as ReactComponent };